'use client'

import * as React from 'react';
import { Message } from 'ai';
import { ChatMessage } from './chat-message';

/**
 * MessageContent Component
 * 
 * Renders the content of a message, including text and tool invocations.
 * This is now a wrapper around the ChatMessage component.
 */
export const MessageContent = React.memo(function MessageContent({ 
  message,
  onRunSqlQuery
}: { 
  message: Message;
  onRunSqlQuery?: (query: string) => void;
}) {
  return (
    <ChatMessage 
      message={message} 
      onRunSqlQuery={onRunSqlQuery} 
    />
  );
}); 